<template>
  <v-select
    v-model="myCurrency"
    :items="items"
    :label="label || $t('views.core.currencySelector.currency')"
    :disabled="disabled"
    :placeholder="placeholder"
    hide-details
    @blur="$emit('blur')"
  ></v-select>
</template>

<script>
import { allCurrencies, supportedCurrencies } from '@/lib/currencies/currencies.js'

export default {
  props: {
    model: {
      type: String,
      default: 'user',
    },
    value: {
      type: String,
      default: null,
    },
    currencyFilter: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    myCurrency: null,
  }),
  computed: {
    items() {
      let items
      if (this.model === 'position') items = supportedCurrencies.sort()
      else if (this.model === 'dividend') items = supportedCurrencies.sort()
      else items = allCurrencies.sort()

      if (this.currencyFilter && this.currencyFilter.length) {
        return items.filter((elem) => {
          return this.currencyFilter.indexOf(elem) > -1
        })
      }
      return items
    },
  },
  watch: {
    myCurrency: {
      handler() {
        if (!this.myCurrency) return
        if (this.myCurrency === this.value) return
        this.$emit('input', this.myCurrency)
      },
      deep: true,
    },
    value: {
      handler() {
        this.myCurrency = this.value
      },
      immediate: true,
    },
  },
}
</script>
